module.exports = __webpack_public_path__ + "static/media/ecommerce_trade.77b35904.jpg";